
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLocationJ as ObiLocationJElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-location-j.js';
 
 
 

 
 export const ObiLocationJ = createComponent({
   react: React,
   tagName: 'obi-location-j',
   elementClass: ObiLocationJElement,
   events: {
     
   }
  });
 
 